import * as Icon from "@iyk/icons"
import * as React from "react"

export const RadioControl = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, children, name, onClick: onClickProp, ...props }, ref) => (
    <label
      htmlFor={props.id}
      className="flex flex-row items-center gap-2 text-sm select-none [&:has(:focus-visible)]:outline outline-gray-11 outline-1 outline-offset-2 rounded-md cursor-pointer"
    >
      <span className="inline-grid size-4">
        <input
          className="row-span-full col-span-full opacity-0 cursor-pointer"
          type="radio"
          name={name}
          ref={ref}
          {...props}
        />
        <span className="flex row-span-full col-span-full bshadow rounded-full bshadow-solid bshadow-gray-8 bg-background [:has(:checked)>&]:bshadow-foreground" />
        <Icon.DotFilled className="row-span-full col-span-full fill-background [:has(:checked)>&]:fill-foreground" />
      </span>
      <span>{children}</span>
    </label>
  ),
)

type RadioProps = JSX.IntrinsicElements["input"]
